import React from 'react';
import { Box, IconButton, Avatar } from '@mui/material';
import { IconMenu2 } from '@tabler/icons';
import FIVBLogo from 'assets/images/icons/fivb-logo-sidemenu.svg';
import User1 from 'assets/images/icons/undraw_pic_profile_re_7g2a.svg';
import 'assets/styles.css';

const MobileHeader = ({ onMenuClick }) => {
  return (
    <Box className="MobileHeader">
      {/* Menu Icon */}
      <IconButton
        onClick={onMenuClick}
        className="MobileHeaderMenuButton"
      >
        <IconMenu2 className="MobileHeaderMenuIcon" />
      </IconButton>

      {/* FIVB Logo */}
      <img
        src={FIVBLogo}
        alt="FIVB Logo"
        className="MobileHeaderLogo"
      />

      {/* User Icon */}
      <Avatar
        src={User1}
        className="MobileHeaderAvatar"
      />
    </Box>
  );
};

export default MobileHeader;
